import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import './DeviceSparkChartContent.scss';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { SkeletonSparkChart } from 'app/agriculture/charts/SkeletonSparkChart/SkeletonSparkChart';
import {
    getAggregateDataFieldRecord,
    useAggregateChartData,
} from 'app/agriculture/hooks/useAggregateChartData/useAggregateChartData';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import {
    useTimelineCursorTime,
    useTimelineViewMode,
} from 'app/agriculture/AgTimeline/context/TimelineContext';
import { GenericSparkChart } from 'app/agriculture/charts/GenericSparkChart/GenericSparkChart';
import { ChartContextProvider } from 'app/agriculture/charts/ChartContextProvider';
import { useContext } from 'react';
import { getBucketInterval } from 'app/agriculture/queries/snapshots/config/bucketConfig';
import { useTimeZone } from 'app/agriculture/hooks/useTimeZone/useTimeZone';

export function DeviceSparkChartContent() {
    return (
        <SuspenseWrapper loadingComponent={<DeviceSparkChartContentSkeleton />}>
            <WrappedDeviceSparkChartContent />
        </SuspenseWrapper>
    );
}

function WrappedDeviceSparkChartContent() {
    const { device } = useContext(DeviceDetailContext);
    const { timeZone } = useTimeZone();
    const cursorTime = useTimelineCursorTime();
    const { aggregationConfig } = useTimelineViewMode();
    const powerData = useAggregateChartData({
        snapshotType: 'Power',
        interval: getBucketInterval(cursorTime, {
            bucketSize: aggregationConfig.bucketSize,
            timeZone,
        }),
        deviceId: device.id,
        intervalUnit: aggregationConfig.intervalUnit,
    });
    const networkData = useAggregateChartData({
        snapshotType: 'Network',
        interval: getBucketInterval(cursorTime, {
            bucketSize: aggregationConfig.bucketSize,
            timeZone,
        }),
        deviceId: device.id,
        intervalUnit: aggregationConfig.intervalUnit,
    });
    return (
        <ContentBox.Section disableDivider className="DeviceSparkChartContent">
            <ChartContextProvider intervalUnit={aggregationConfig.intervalUnit}>
                <SimpleGrid columns={3}>
                    <GenericSparkChart
                        data={getAggregateDataFieldRecord(powerData, 'batteryLevelAvg')}
                        title="Avg Battery Charge"
                        displayUnit={'%'}
                    />
                    <GenericSparkChart
                        data={getAggregateDataFieldRecord(powerData, 'solarVoltageAvg')}
                        title={'Avg Solar Voltage'}
                        displayUnit={'mV'}
                    />
                    <GenericSparkChart
                        data={getAggregateDataFieldRecord(networkData, 'rssiAvg')}
                        title="Avg RSSI"
                        displayUnit={'dBm'}
                    />
                </SimpleGrid>
            </ChartContextProvider>
        </ContentBox.Section>
    );
}

function DeviceSparkChartContentSkeleton() {
    return (
        <ContentBox.Section disableDivider className="DeviceSparkChartContent">
            <SimpleGrid columns={3}>
                <div>
                    <SkeletonSparkChart title="Avg Battery Charge" />
                </div>
                <div>
                    <SkeletonSparkChart title="Avg Solar Voltage" />
                </div>
                <div>
                    <SkeletonSparkChart title="Avg RSSI" />
                </div>
            </SimpleGrid>
        </ContentBox.Section>
    );
}
